module.exports = __webpack_public_path__ + "static/media/googleplay.142f41c8.svg";